import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0895e255"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StatusesTable" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_3 = { class: "CmsInvoices" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col items-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении списка произошла ошибка", -1))
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scrollbar-content" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "header-item" }
const _hoisted_12 = { class: "CmsInvoices__count" }
const _hoisted_13 = { class: "body-item__header" }
const _hoisted_14 = { class: "body-item__header" }
const _hoisted_15 = {
  key: 1,
  class: "CmsInvoices__delivery"
}
const _hoisted_16 = {
  key: 2,
  class: "CmsInvoices__delivery"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 4 }
const _hoisted_21 = {
  key: 5,
  class: "body-item__red"
}
const _hoisted_22 = { class: "mt-2 font-semibold" }
const _hoisted_23 = {
  key: 6,
  class: "body-item__services"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_invoice_status_row = _resolveComponent("invoice-status-row")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.is_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Статусы ЛО",
          scrollable: "",
          loading: _ctx.state.is_loading,
          onCancel: _ctx.closeLo,
          overflow: "",
          "without-footer": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_loader, { class: "primary" })
                  ]))
                : (_openBlock(), _createBlock(_component_new_table, {
                    key: 1,
                    columns: _ctx.COLUMNS,
                    rows: _ctx.state.statuses_lo
                  }, {
                    td: _withCtx(({ column, row }) => [
                      _createVNode(_component_invoice_status_row, {
                        column: column,
                        row: row
                      }, null, 8, ["column", "row"])
                    ]),
                    _: 1
                  }, 8, ["columns", "rows"]))
            ])
          ]),
          _: 1
        }, 8, ["loading", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading || _ctx.failed || !_ctx.items)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.failed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_new_button, {
                      class: "mt-1",
                      onClick: _ctx.refresh
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перезагрузить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (!_ctx.items)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Список пуст"))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              ref: "scrollTop",
              class: "scrollbar-top",
              onScroll: _cache[0] || (_cache[0] = ($event: any) => (_ctx.syncScroll('top')))
            }, _hoisted_10, 544),
            _createElementVNode("div", {
              ref: "scrollMain",
              class: "CmsInvoices__container",
              onScroll: _cache[1] || (_cache[1] = ($event: any) => (_ctx.syncScroll('main')))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `c-${i}`
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(column.name) + " ", 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getCount(column.key)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getItems(column.key), (item, k) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `body-item-${k}`,
                        class: _normalizeClass(["body-item", {
                                'body-red': item.colorId === 1,
                                'body-blue': item.colorId === 2,
                            }])
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_router_link, {
                            class: "body-item__link",
                            to: `/invoice/${item.id}`,
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.invoiceNumber), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("i", {
                            class: _normalizeClass(_ctx.getIcon(item.shipmentType.id))
                          }, null, 2)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          (item.hasWaitListStatuses)
                            ? (_openBlock(), _createBlock(_component_cheap, {
                                key: 0,
                                class: "small blue body-item__lo",
                                onClick: ($event: any) => (_ctx.openLo(item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" ЛО ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        (item.status)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 0,
                              class: _normalizeClass(`small mb-3 font-bold ${_ctx.getCheapClass(item.status.id)}`)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.status.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          : _createCommentVNode("", true),
                        (item.isPickup)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Самовывоз"))
                          : _createCommentVNode("", true),
                        (item.isSelfDelivery)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Самопривоз "))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, _toDisplayString(item.company ? item.company.name : '-'), 1),
                        _createElementVNode("p", null, _toDisplayString(item.direction), 1),
                        ((column.key === 'onDelivery' || column.key === 'delivered'))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (item.cashSum || Number(item.codPayment))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Оплачено: " + _toDisplayString(item.isPaid ? 'Да' : 'Нет'), 1))
                                : _createCommentVNode("", true),
                              (item.cashSum)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Наличные: " + _toDisplayString(item.cashSum), 1))
                                : _createCommentVNode("", true),
                              (Number(item.codPayment))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Наложенный платёж: " + _toDisplayString(item.codPayment), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (item.tripId && column.key === 'inTransit')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                              _createTextVNode(" Рейс: "),
                              _createVNode(_component_router_link, {
                                to: `/tms/trips/${item.tripId}`,
                                class: "text-blue-500",
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.tripNumber), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          : _createCommentVNode("", true),
                        (item.needSetCashSum)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Наличка не внесена "))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.getDateTitle(item)) + ": " + _toDisplayString(_ctx.formatDate(item.predictDate)), 1),
                        (item.additionalServices?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.additionalServices, (service, j) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: `service-${j}`,
                                  class: "body-item__service"
                                }, _toDisplayString(service.type?.name), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ]))
              }), 128))
            ], 544)
          ]))
    ])
  ], 64))
}